import webApi from "./api";
import store from "@/store";

export class VehicleInfoService {
  getInfoRedbook(params) {
    return webApi.get("/car-detail/redbook-october", {
      params,
    });
  }
  getInfoAutograb(params) {
    return webApi.get("/car-detail/autograb", {
      params,
    });
  }
  async getInfo(params) {
    // Get system configuration to determine vehicle data source
    const vehicleDataSource = store.getters.systemConfigurations.vehicleDataSource;

    // Check if activeSource is RB, then use searchRedbookRego
    if (vehicleDataSource?.activeSource === "RB") {
      return this.getInfoRedbook(params);
    }
    // Check if activeSource is AG, then use searchAutograbRego
    else if (vehicleDataSource?.activeSource === "AG") {
      return this.getInfoAutograb(params);
    }
    // Default fallback to redbook API
    else {
      return this.getInfoRedbook(params);
    }
  }
  getInfoByRego(regoNumber, state) {
    return webApi.post("/car-detail/rego-search", { regoNumber, state });
  }
}

const vehicleInfoService = new VehicleInfoService();

export default vehicleInfoService;
